import { getVisitorIds } from "./visitorTracker";
// Visitor attribution + safe gtag event helpers. All calls are no-ops if gtag is missing.
const ATTR_KEY = "nt-attribution";

export interface Attribution {
  landingPage?: string;
  referrer?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
}

export const trackEvent = (name: string, params: Record<string, unknown> = {}) => {
  try {
    const g = (window as any).gtag;
    if (typeof g === "function") g("event", name, params);
  } catch {
    /* ignore */
  }
};

export const captureAttribution = () => {
  try {
    if (localStorage.getItem(ATTR_KEY)) return;
    const p = new URLSearchParams(window.location.search);
    const attr: Attribution = {
      landingPage: window.location.pathname + window.location.search,
      referrer: document.referrer || undefined,
      utmSource: p.get("utm_source") || undefined,
      utmMedium: p.get("utm_medium") || undefined,
      utmCampaign: p.get("utm_campaign") || undefined,
    };
    localStorage.setItem(ATTR_KEY, JSON.stringify(attr));
  } catch {
    /* ignore */
  }
};

export const getDeviceType = () => {
  const w = window.innerWidth;
  if (/Mobi|Android|iPhone/i.test(navigator.userAgent) || w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
};

/** Payload fields to merge into every quote submission. */
export const getTrackingPayload = () => {
  let attr: Attribution = {};
  try {
    attr = JSON.parse(localStorage.getItem(ATTR_KEY) || "{}");
  } catch {
    /* ignore */
  }
  return {
    ...attr,
    uiLanguage: localStorage.getItem("app-language") || document.documentElement.lang || "no",
    deviceType: getDeviceType(),
    ...getVisitorIds(),
  };
};

export const initTracking = () => {
  captureAttribution();
  document.addEventListener(
    "click",
    (e) => {
      const a = (e.target as HTMLElement | null)?.closest?.("a");
      const href = a?.getAttribute("href") || "";
      if (/wa\.me|whatsapp\.com/i.test(href)) {
        trackEvent("whatsapp_click", { page_path: window.location.pathname });
      }
    },
    true
  );
  window.addEventListener("message", (e) => {
    if (typeof e.origin === "string" && e.origin.includes("calendly.com") && e.data?.event === "calendly.event_scheduled") {
      trackEvent("calendly_booking", { page_path: window.location.pathname });
    }
  });
};
